// packages
import { h, hydrate, render } from 'preact';

// local
import { NAME_MAPPING } from './constants';

export function prepareResults(data) {
  const { results } = data;

  const output = results
    .sort((a, b) => b.votes - a.votes)
    .map(result => {
      const name = NAME_MAPPING[result.name];
      const votes = result.votes;
      const party = result.party;
      const pct = (result.vote_pct * 100).toFixed(1);

      return Object.assign({}, name, { votes, party, pct });
    });

  return output;
}

class ContextProvider {
  getChildContext() {
    return this.props.context;
  }
  render(props) {
    return props.children;
  }
}

/**
 * Portal component
 * @param {object | null | undefined} props
 */
function Portal(props) {
  let wrap = h(ContextProvider, { context: this.context }, props.vnode);
  let container = props.container;
  hydrate(wrap, container);
  this.componentWillUnmount = () => {
    render(null, container);
  };
  return null;
}

/**
 * Create a `Portal` to continue rendering the vnode tree at a different DOM node
 * @param {import('./internal').VNode} vnode The vnode to render
 * @param {import('./internal').PreactElement} container The DOM node to continue rendering in to.
 */
export function createPortal(vnode, container) {
  return h(Portal, { vnode, container });
}

/**
 *
 * @param {object[]} arr
 * @param {string} key
 * @returns {number}
 */
export function sumValues(arr, key) {
  return arr.reduce((total, obj) => total + obj[key], 0);
}
